/** Format 24h "14:30" or ISO to "02:30 PM" */
export function formatTime12h(time) {
  if (!time || time === '—') return '—';
  if (/am|pm/i.test(time)) return time;

  const isoMatch = time.match(/T(\d{2}):(\d{2})/);
  const hours = isoMatch ? Number(isoMatch[1]) : Number(time.split(':')[0]);
  const minutes = isoMatch ? isoMatch[2] : time.split(':')[1] || '00';

  if (Number.isNaN(hours)) return time;

  const h12 = hours % 12 || 12;
  const ampm = hours >= 12 ? 'PM' : 'AM';
  return `${String(h12).padStart(2, '0')}:${minutes} ${ampm}`;
}

export function formatResultDate(dateStr) {
  if (!dateStr || dateStr === 'Flexible') return 'Flexible dates';
  try {
    const normalized = dateStr.includes('T') ? dateStr : `${dateStr}T12:00:00`;
    const d = new Date(normalized);
    if (Number.isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return dateStr;
  }
}

export function formatPriceParts(amount, currency = 'USD') {
  const value = Number(amount) || 0;
  const [whole, cents] = value.toFixed(2).split('.');
  const symbol = currency === 'USD' ? '$' : currency;
  return { currency, whole, cents, symbol, formatted: value.toFixed(2) };
}

export function stopsLabel(stops) {
  const n = Number(stops) || 0;
  if (n === 0) return 'Non Stop';
  if (n === 1) return '1 Stop';
  return `${n} Stops`;
}

export function locationCode(label, fallback = '—') {
  if (!label) return fallback;
  const paren = label.match(/\(([A-Z]{3})\)/i);
  if (paren) return paren[1].toUpperCase();
  if (/^[A-Za-z]{3}$/.test(label.trim())) return label.trim().toUpperCase();
  const words = label.trim().split(/\s+/);
  if (words.length >= 2) return words.map((w) => w[0]).join('').slice(0, 3).toUpperCase();
  return label.slice(0, 3).toUpperCase();
}
